import {
  URL_CONSULTATION,
  URL_DISCORD,
  URL_INSTAGRAM,
  URL_YOUTUBE,
} from '../../footer/links.constants';

export const menuItems = [
  {
    title: 'Shop',
    content: [
      { title: 'Bespoke', link: '/shop/bespoke' },
      { title: 'Made to Measure', link: '/shop/mtm' },
      { title: 'Accessories', link: '/shop/accessories' },
      { title: 'Fabrics', link: '/shop/fabrics' },
      { title: 'Personal Styling', link: '/shop/personal-styling' },
      { title: 'Gift Card', link: '/shop/gift-card' },
      { title: 'View All', link: '/shop' },
    ],
  },
  {
    title: 'Apps',
    content: [
      { title: 'Color Genie', link: '/color-genie' },
      { title: 'Genie', link: '/genie' },
    ],
  },
  {
    title: 'Social',
    content: [
      { title: 'Instagram', url: URL_INSTAGRAM },
      { title: 'Discord', url: URL_DISCORD },
      { title: 'YouTube', url: URL_YOUTUBE },
    ],
  },
  {
    title: 'Contact',
    content: [
      { title: 'Contact Us', link: '/contact-us' },
      { title: 'Book an Appointment', url: URL_CONSULTATION },
    ],
  },
  {
    title: 'Learn More',
    content: [
      { title: 'Our Process', link: '/our-process' },
      { title: 'Our Workshop', link: '/our-workshop' },
      { title: 'FAQ', link: '/faq' },
      { title: 'Gallery', link: '/gallery' },
      { title: 'Blog', url: 'https://blog.askokey.com' },
      { title: 'About Us', link: '/about-us' },
      { title: 'Privacy Policy', link: '/privacy-policy' },
      { title: 'Terms of Service', link: '/terms-of-service' },
    ],
  },
  {
    title: 'Policy',
    content: [
      { title: 'Returns and Refunds', link: '/returns-and-refunds' },
      { title: 'Terms of Service', link: '/terms-of-service' },
    ],
  },
];
